import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { UiBackBreadCrumb } from "../../../_uiComponents/UiBackBreadCrumb";
import { UiWhiteCard } from "../../../_uiComponents/common/UiWhiteCard";
import { UiScheduleIterationDetail } from "../../../_uiComponents/SchedulePayments/UiScheduleIterationDetail";
import { useDispatch, useSelector } from "react-redux";
import {
  changeIterationStatusRequest,
  setActiveView,
} from "../../../../_redux/_actions";
import { schedulePaymentsConstants } from "../../../../_redux/_constants";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { ConfirmationPopupWithCustomButton } from "../../../_uiComponents/Popups/ConfirmationPopup";

const ScheduleIterationDetail = () => {
  const dispatch = useDispatch();
  const [openStopSchedule, setOpenStopSchedule] = useState(false);
  const {
    schedulePaymentsDetails,
    isChangeIterationStatusLoading,
    selectedIterationData,
    changeIterationStatusSuccess,
  } = useSelector((state) => state.schedulePayments);

  const backFromForm = () => {
    dispatch(
      setActiveView(
        schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_SUMMARY,
      ),
    );
  };

  const handleStopSchedule = () => {
    dispatch(
      changeIterationStatusRequest({
        iterationId: selectedIterationData?.recurringTransactionIterationId,
        status:
          schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED,
        scheduledType: schedulePaymentsDetails?.scheduledPaymentType,
      }),
    );
  };

  const handleCloseModal = () => {
    setOpenStopSchedule(false);
  };

  useEffect(() => {
    if (changeIterationStatusSuccess) {
      setOpenStopSchedule(false);
    }
  }, [changeIterationStatusSuccess]);

  return (
    <>
      <div className="df-user-profile">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__body df-bill-payment-form">
            <div>
              <UiBackBreadCrumb
                backOnClick={backFromForm}
                titleText="Schedule Details"
                disableCloseButton
              />

              <UiWhiteCard className="df-schedule-detail-form__wrapper">
                <div className="df-common-setting-cards">
                  <UiScheduleIterationDetail
                    onStopClick={() => setOpenStopSchedule(true)}
                    isStopLoading={isChangeIterationStatusLoading}
                  />
                </div>
              </UiWhiteCard>
            </div>
          </div>
        </Container>

        <UiPopup openModal={openStopSchedule} handleClose={handleCloseModal}>
          <ConfirmationPopupWithCustomButton
            icon={<ConfirmationIcon />}
            CancelButtonName="Cancel"
            SuccessButtonName="Yes"
            message="Stop Schedule"
            buttonOnClick={handleStopSchedule}
            className="df-confirmation-message-popup df-btn-grpdmodal"
            buttonOnClickClose={handleCloseModal}
          >
            <p>Are you sure you want stop this schedule ?</p>
          </ConfirmationPopupWithCustomButton>
        </UiPopup>
      </div>
    </>
  );
};

export default ScheduleIterationDetail;
